var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoyageProfileMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "466 156 1141 1457",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M1011,1398 828,1398 918,1588Z M1323,765 1125,765 924,1196 738,774 598,924 598,930 820,1381 1020,1381Z M1582,309 1490,180 490,711 502,734 754,749Z M859,528 901,657 741,742 705,610Z M1171,363 1213,492 1053,577 1017,445Z M1483,198 1524,327 1364,412 1328,280Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#275bc1",
    d: "M512,752 588,908 720,766 719,764Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoyageProfileMark);
export default __webpack_public_path__ + "static/media/voyage-profile-mark.73caee83f6956ed5524c646e3435b816.svg";
export { ForwardRef as ReactComponent };